export default "__VITE_ASSET__DXgVhlo7__"